import queryClient from '../../../ReactQuery/client';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';
import { nuc } from '../../../utils';
import { getQueryKey as getRevisionQueryKey } from '../revisions/useRevision';
import type { AddLicenseToProjectCorrectionRequest } from '../../../../shared/types/licenses';

type AddLicenseParams = {
  body: AddLicenseToProjectCorrectionRequest;
  dependencyRevisionLocator: string;
};

const addLicense = ({
  body,
  dependencyRevisionLocator,
}: AddLicenseParams) => {
  return post<AddLicenseToProjectCorrectionRequest, void>(`/api/v2/revisions/${nuc(dependencyRevisionLocator)}/correction/license`, body);
};

export const useAddLicense = (
  dependencyRevisionLocator: string,
) => {
  return useToastedMutation({
    mutationFn: ({
      body,
    }: AddLicenseParams) =>
      addLicense({
        body,
        dependencyRevisionLocator,
      }),
    successToastMessage: 'License added successfully',
    errorToastMessage: 'Failed to add license',
    onSuccess: async () => {
      // We're using the predicate approach here because dependency fetching can happen at the project and release group
      // levels, and we want to invalidate the dependencies for both. This approach allows us to avoid needing to query
      // for all of the affected projects and release groups to utilize the getQueryKey helper for those fetches.
      void queryClient.invalidateQueries({
        predicate: (query) => {
          const key = query.queryKey;
          return key.includes('dependencies') && key.includes(dependencyRevisionLocator);
        },
      });
      void queryClient.invalidateQueries({
        queryKey: getRevisionQueryKey(dependencyRevisionLocator),
      });
    },
  });
};
